import z from "zod";

export const ShopifyPartnerTierSchema = z.enum(['none', 'select', 'plus', 'premier', 'platinum']);
export type ShopifyPartnerTier = z.infer<typeof ShopifyPartnerTierSchema>;

export const AppTierSchema = z.union([z.null(), z.literal('built_for_shopify')]);
export type AppTier = z.infer<typeof AppTierSchema>;

export const PackagedServicePriceTypeSchema = z.enum(['fixed', 'monthly']);
export type PackagedServicePriceType = z.infer<typeof PackagedServicePriceTypeSchema>;

export const ExpertTypeSchema = z.enum(['freelancer', 'agency']);
export type ExpertRecordType = z.infer<typeof ExpertTypeSchema>;

export const ListingTypeSchema = z.enum(['freelancer', 'agency', 'app_service_provider']);
export type ListingType = z.infer<typeof ListingTypeSchema>;

export const ExpertTypeInputSchema = z.enum(['freelancer', 'agency', 'app_service_provider']);
export type ExpertTypeInput = z.infer<typeof ExpertTypeInputSchema>;

export const AgencyTypeSchema = z.union([z.null(), z.literal('app_service_provider')]);
export type AgencyType = z.infer<typeof AgencyTypeSchema>;

export const AgencySubtypeFieldSchema = z.union([
    z.object({
        type: z.string().optional(),
        required: z.boolean().optional(),
        value: z.union([z.string(), z.null()]).optional(),
        options: z.array(z.union([z.string(), z.null()])).optional(),
    }),
    z.string(),
    z.null(),
]);
export type AgencySubtypeField = z.infer<typeof AgencySubtypeFieldSchema>;

export const AppTierFieldSchema = z.union([
    AppTierSchema,
    z.object({
        type: z.string().optional(),
        required: z.boolean().optional(),
        value: AppTierSchema.optional(),
        options: z.array(AppTierSchema).optional(),
    }),
]);
export type AppTierField = z.infer<typeof AppTierFieldSchema>;

export const AgencyTypeFieldsSchema = z.record(z.string(), AgencySubtypeFieldSchema);
export type AgencyTypeFields = z.infer<typeof AgencyTypeFieldsSchema>;

export const AgencySubtypeMetaSchema = z.object({
    agency_type: AgencyTypeSchema,
    agency_type_fields: AgencyTypeFieldsSchema,
});
export type AgencySubtypeMeta = z.infer<typeof AgencySubtypeMetaSchema>;
